import ReactGA from 'react-ga4';

export const useAnalytics = () => {
    function sendPageView(route: string) {
        ReactGA.send({hitType: 'pageview', page: route});
    }

    function sendEvent(category: string, action: string, label?: string, value?: number) {
        ReactGA.event({
            category: category,
            action: action,
            label: label,
            value: value,
        });
    }

    return {
        sendPageView,
        sendEvent,
    };
};
